exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-container{display:flex;flex-direction:column}.contact-container>*{width:100%}", ""]);

// exports
